import React, {useState, useEffect, useRef} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'; 
import TextField from '@mui/material/TextField';
import {StyledFormContainer} from '../Components/Styled/index';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import history from '../Utility/history';
import { privateRoutesPath, publicRoutesPath } from '../Routes';
import axios from 'axios';
import {useSnackbar} from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import BiztantuLoader from '../Components/Loader';
import { requestShowLoader, requestHideLoader } from '../Store/Global/action';
import { requestgetcurrenctuser } from '../Store/User/action';
import GeneralDialog from '../Components/Dialog';
import { IconButton, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import bticon from '../Assets/images/biztantu-logo-full.png';
const theme = createTheme({
    typography: {
      subtitle2: {
        fontStyle: 'italic',
      }
    },
});


const LoginPage = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [currentUser , setCurrentUser] = useState({
        username: '',
        password: ''
    });
    const dispatch = useDispatch();
    const [isOpen, setisOpen] = useState(false);
    const [requiredLogin, setRequiredLogin] = useState({
      username: false,
      password: false
    })

    const [showPassword, setShowPassword] = useState(false);

    const userNameRef = useRef(null);

    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    
    const isLoading = useSelector(state => state.global.isLoading)

    useEffect(() => {
        renderSpecificRoutes();
    },[specificRolePermission])

  const renderSpecificRoutes = () => {
      
        if(specificRolePermission?.isConfigurationView) {
          history.push(privateRoutesPath.CONFIGURATION);
          return true;
        }

  }


    //handle input formfield
    const handleChange = (event) => {
        const{ name , value} = event.target;
        setCurrentUser({
            ...currentUser,
            [name]: value
        })
    }



    //handle Login Button
    const handlelogin = (event) => {

      event?.preventDefault();
      
      if(currentUser?.username && currentUser?.password) {
        dispatch(requestShowLoader())
        const payload = {
        username :  (currentUser.username || "").trim(),
        password :  currentUser?.password
        }
        axios.post(`${process.env.REACT_APP_BASE_URL}authenticate`, payload).then(response => {
          const token = response?.data?.token;
          dispatch(requestHideLoader())
          if(token) {
            // localStorage.setItem('accessToken', token);
            dispatch(requestgetcurrenctuser(token));
            
            // history.push(privateRoutesPath.DASHBOARD);
          }

          setRequiredLogin({
            username: false,
            password: false
          })
          
        }).catch(error => {
          dispatch(requestHideLoader())
          setRequiredLogin({
            username: true,
            password: true
          })
          enqueueSnackbar(error?.response?.data, {variant: 'error'});
        })
      } else {

        userNameRef?.current?.focus();
        setRequiredLogin({
          username: true,
          password: true
        })
      }
       
      
    }

  const handleForgotPassword = (e)=> {
     e.preventDefault();
    setisOpen(true);
  }
    
  return (
    <BiztantuLoader open={isLoading} isChildren={true}>
     <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid 
            container 
            direction="row"
            flexWrap="nowrap"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            className="gridContainer"
          >
            <Grid item xs={8}></Grid>
            <Grid className='textCenter' item xs={8}>
                {/* <Typography variant="h6" gutterBottom component="div">
                    Biztantu
                </Typography> */}
                {/* <Typography variant="subtitle2" gutterBottom component="div">
                    Powerd By BizTantu
                </Typography> */}

                 <div style={{marginBottom: "20px"}}>
                  <img src= {bticon} style={{width: "50%", height: "100%", objectFit: 'contain'}}/>
                  <b>ADMIN</b>
                </div>
                
                <form onSubmit={handlelogin}>
                 
                <StyledFormContainer>
                 
                    <TextField 
                        id="outlined-basic" 
                        inputRef={userNameRef}
                        label="Username" 
                        variant="outlined" 
                        type="text"
                        className='mb-15'
                        name="username"
                        error={currentUser?.username ? false : requiredLogin?.username}
                        onChange={handleChange}
                        value={currentUser.username}
                        required
                        InputLabelProps={{
                          shrink: true,
                      }}
                      placeholder="Enter your username"
                    />
                    <TextField 
                        id="outlined-basic" 
                        error={currentUser?.password ? false : requiredLogin?.password}
                        label="Password" 
                        variant="outlined" 
                        className='mb-15'
                        name="password"
                        onChange={handleChange}
                        value={currentUser.password}
                        required
                        type={showPassword ? 'text' : 'password'}
                        InputProps= {{endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword((show) => !show)}
                              onMouseDown={(event) => event.preventDefault()}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                          </InputAdornment>
                        )}}
                        InputLabelProps={{
                          shrink: true,
                      }}
                      placeholder="Enter your password"
                    />

                    <Button variant="contained" type='submit'>Login</Button>
                    <Link
                        component="button"
                        variant="body2"
                        className='mt-20'
                        // onClick={() => {
                        //     history.push(publicRoutesPath.FORGOTPASSWORD);
                        // }}

                        onClick={handleForgotPassword}
                        >
                            Forgot Password
                        </Link>
                    </StyledFormContainer>
                    </form>
                
            </Grid>
            <Grid item xs={8}></Grid>
          </Grid>
        </Box>
      </ThemeProvider>
      <GeneralDialog
        title = "Forgot Password"
        btnlabel={"OK"}
        open={isOpen}
        handleSave={() => setisOpen(false)}
      >
            <Typography variant='subtitle1'>
            Reach out to info@biztantu.com for further assistance.
            </Typography>
      </GeneralDialog>
    </BiztantuLoader>
  );
}


export default LoginPage;